module.exports = __webpack_public_path__ + "img/00.15cc04f9.jpg";